import {
  API_ENDPOINT,
  useClientApiV1AuthChangePasswordVerificationEmailCreateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthChangePasswordVerificationEmailCreateMutation(
  options?: Parameters<
    typeof useClientApiV1AuthChangePasswordVerificationEmailCreateMutation
  >[0]['options'],
) {
  return useClientApiV1AuthChangePasswordVerificationEmailCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_AUTH_CHANGE_PASSWORD_VERIFICATION_EMAIL,
    options,
  });
}

export default useClientAuthChangePasswordVerificationEmailCreateMutation;
